import {Params} from '../getConfig'

export const amplifyElalProduction: Params = {
  aws_user_pools_id: 'eu-west-1_yinTT13KS',
  aws_cognito_identity_pool_id: '', // Not needed for any partner
  aws_user_pools_web_client_id: '7f9vab28vkfrhm606kov084rro',
  oauth_domain: 'elal-auth-production.auth.eu-west-1.amazoncognito.com',
  aws_user_files_s3_bucket: '' // Not needed for any partner
}
